import * as actionTypes from "../actionTypes";

export const emptyToastMsg = () => ({
  type: actionTypes.EMPTY_TOAST_MSG,
});

export const showNotification = (id, text, msgtype) => {
  return { type: actionTypes.TOAST_MSG, id, text, msgtype };
};

export const hideNotification = (id) => {
  return { type: actionTypes.HIDE_TOAST_MSG, id };
};

export const showNotificationWithTimeout = (text, msgtype) => {
  // if (msgtype == "success") {
  //   toast.success(text);
  // } else if (msgtype == "error") {
  //   toast.error(text);
  // } else {
  //   toast(text);
  // }
  return { type: actionTypes.SHOW_NOTIFICATION_WITH_TIMEOUT, text, msgtype };
};
export const emptyAlertMsg = () => ({
  type: actionTypes.EMPTY_ALERT_MSG,
});

export const showAlert = (title, text, msgtype = "error") => {
  return { type: actionTypes.ALERT_MSG, title, text, msgtype };
};
